import React from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import AddBlogs from '../../components/addBlogs'
import Breadcrum from '../../components/breadcrum'
import { FaArrowLeft } from 'react-icons/fa'

const AddBlog = () => {
  const { id } = useParams() // For edit mode, get ID from URL params
  const location = useLocation()
  const navigate = useNavigate()

  // Determine if this is edit mode based on URL or state
  const isEdit = location.pathname.includes('edit') || !!id

  return (
    <>
      <Breadcrum
        heading="Opinion"
        subheading={isEdit ? 'Edit Opinion' : 'Add Opinion'}
      />
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex justify-center items-center bg-gray-500 p-2 text-white rounded sticky -top-[15px]"
      >
        <FaArrowLeft />
        &nbsp; Back
      </button>
      <AddBlogs blogId={id} isEdit={isEdit} />
    </>
  )
}

export default AddBlog
